import dayjs, { Dayjs } from "dayjs";
import i18n from "@/i18n";
import { getWeekList } from "@/components/Calendars/utils";

export interface cardScheduleItem {
  scheduleId: string;
  title: string;
  beginTime: number;
  endTime: number;
  color: string;
  userName: string;
  desc: string;
}

/**
 * 工作台日程卡片周视图header显示当周的日期时间格式
 */
export function formatCardWeekDate(curDate: Dayjs) {
  const week: Dayjs[] = getWeekList(curDate, true);
  const beginDate = week[0];
  const endDate = week[week.length - 1];
  let weekBeginDate = beginDate.format(
    "MM" + i18n.t("calendar:month") + "DD" + i18n.t("calendar:day")
  );
  let weekEndDate = endDate.format("MM" + i18n.t("calendar:month") + "DD" + i18n.t("calendar:day"));
  // 跨年 开始和结束时间都加年份 非当年-往年，开始时间加年份 非当年未来年，开始时间加年份
  if (!beginDate.isSame(endDate, "year")) {
    weekBeginDate = beginDate.format(
      "YYYY" +
        i18n.t("calendar:year") +
        "MM" +
        i18n.t("calendar:month") +
        "DD" +
        i18n.t("calendar:day")
    );
    weekEndDate = endDate.format(
      "YYYY" +
        i18n.t("calendar:year") +
        "MM" +
        i18n.t("calendar:month") +
        "DD" +
        i18n.t("calendar:day")
    );
  } else if (!beginDate.isSame(dayjs(), "year")) {
    weekBeginDate = beginDate.format(
      "YYYY" +
        i18n.t("calendar:year") +
        "MM" +
        i18n.t("calendar:month") +
        "DD" +
        i18n.t("calendar:day")
    );
  }

  if (beginDate.isSame(dayjs(), "week")) {
    return "本周日程（" + weekBeginDate + "-" + weekEndDate + ")";
  }
  return weekBeginDate + "-" + weekEndDate;
}

/**
 * 工作台日程卡片每天日期
 */
export function formatCardDate(date: Dayjs) {
  if (date.isSame(dayjs(), "day")) {
    return (
      date.format("MM" + i18n.t("calendar:month") + "DD" + i18n.t("calendar:day")) +
      " " +
      i18n.t("calendar:week_" + date.day()) +
      "（" +
      i18n.t("calendar:today") +
      "）"
    );
  } else if (date.isSame(dayjs(), "year")) {
    return (
      date.format("MM" + i18n.t("calendar:month") + "DD" + i18n.t("calendar:day")) +
      " " +
      i18n.t("calendar:week_" + date.day())
    );
  } else {
    return (
      date.format(
        "YYYY" +
          i18n.t("calendar:year") +
          "MM" +
          i18n.t("calendar:month") +
          "DD" +
          i18n.t("calendar:day")
      ) +
      " " +
      i18n.t("calendar:week_" + date.day())
    );
  }
}
